module.exports = __webpack_public_path__ + "static/house-on-fire-63af75371ed7154389757e91307ef68a.jpg";